import { ClientService, ToastMessageService } from '@fitness-force/api';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { BadRequestError, ErrorMsgComponent, NotFoundError } from '@fitness-force/errors';
import { confirmationTextValidator } from '@fitness-force/shared';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import {  ShortNamePipe} from '@fitness-force/pipes/short-name'
@Component({
  selector: 'block-client',
  templateUrl: './block-client.component.html',
  styleUrls: ['./block-client.component.scss'],
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    CommonModule,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    BlockUIModule,
    StyleClassModule,
    InputTextModule,
    PasswordModule,
    ShortNamePipe,
    AvatarModule,
    TranslateModule,
    ErrorMsgComponent
  ],
})
export class BlockClientComponent implements OnInit {
  @Input() blockClientModal: boolean | null = false;
  @Input() clientData$: any = new BehaviorSubject(null)
  @Output() closeBlockClientDialog = new EventEmitter()

  blockClientFromGroup: UntypedFormGroup = new UntypedFormGroup({});

  allClientData: any;
  btnLoading:boolean=false;
  constructor(private fb: UntypedFormBuilder,
     public translate: TranslateService,
      private clientService: ClientService, 
      private toastMessageService: ToastMessageService,
      private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.componentInit()
  }

  componentInit() {
    this.blockClientFromGroup = this.fb.group({
      confirmationText: [''],
      confirmationDescription: [''],
      clientName: []
    })
    this.clientData$.subscribe(
      (client: any) => {
        this.allClientData = client

        if (this.allClientData.is_blacklisted) {
          this.ConfirmationText.setValidators([Validators.required, confirmationTextValidator('clientName', 'unblocked', false)]);

        } else {
          this.ConfirmationText.setValidators([Validators.required, confirmationTextValidator('clientName', 'blocked', false)]);
          this.ConfirmationDescription.setValidators([Validators.required]);
        }
        this.ClientName.setValue(this.allClientData.full_name)
      })


  }
  closeDialogEvent(action: string | null = null) {
    this.closeBlockClientDialog.emit({ close: true, action })
    this.ConfirmationDescription.setValidators(null);
  }

  blockUnBlockClient() {
    this.btnLoading=true;
    const blockClientModel = {
      "reason": this.ConfirmationDescription.value
    }
    let tenantid=0;
    if(this.allClientData.home_club_tenant_id && this.allClientData.home_club_tenant_id > 0) tenantid = this.allClientData.home_club_tenant_id;
    else tenantid= this.allClientData.createdin_tenant_id;
    if (this.allClientData.is_blacklisted) {
      this.clientService.clientRemoveFromBlacklist(this.allClientData.id, tenantid).subscribe({
        next: (res: any) => {
          this.translate.get('CLIENT_PROFILE.BLOCK_CLIENT.UNBLOCKED_SUCCESS').subscribe((translations: any) => {
            this.toastMessageService.showSuccess(translations);
          });
          this.btnLoading=false;
          this.closeDialogEvent("block");
        },
        error: (error) => {
          this.btnLoading=false;
          this.toastMessageService.showError(error);
         this.cd.detectChanges();
        }
      })
    } else {
      this.clientService.clientAddToBlacklist(this.allClientData.id, tenantid, blockClientModel).subscribe({
        next: (res: any) => {
          this.translate.get('CLIENT_PROFILE.BLOCK_CLIENT.BLOCKED_SUCCESS').subscribe((translations: any) => {
            this.toastMessageService.showSuccess(translations);
          });
          this.btnLoading=false;
          this.closeDialogEvent("unblock");
          this.cd.detectChanges();
        },
        error: (error) => {
         this.btnLoading=false;
         this.toastMessageService.showError(error);
         this.cd.detectChanges();
        }
      })
    }
  }

  get ConfirmationText(): UntypedFormControl {
    return this.blockClientFromGroup.get('confirmationText') as UntypedFormControl;
  }
  
  get ConfirmationDescription(): UntypedFormControl {
    return this.blockClientFromGroup.get('confirmationDescription') as UntypedFormControl;
  }

  get ClientName(): UntypedFormControl {
    return this.blockClientFromGroup.get('clientName') as UntypedFormControl;
  }

}